import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=31782f18&scoped=true"
import script from "./Products.js?vue&type=script&lang=js&external"
export * from "./Products.js?vue&type=script&lang=js&external"
import style0 from "./Products.scss?vue&type=style&index=0&id=31782f18&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31782f18",
  null
  
)

export default component.exports